import { useMediaQuery } from '@mui/material'
import classNames from 'classnames'
import React, { useContext } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { QuizDebounceModal } from '@f/applications/QuizApp/modals/QuizDebounceModal'
import Modal from '@f/components/Modal'
import StarRating from '@f/components/StarRating'
import { PlatformLogo } from '@f/elements/PlatformLogo/PlatformLogo'
import { PlatformLogoOnWhite } from '@f/elements/PlatformLogo/PlatformLogoOnWhite'

const backgroundTypeByDomain = {
  fertighaus: 'dark',
  massivhaus: 'light',
  einfamilienhaus: 'light',
  bungalow: 'light',
  bauen: 'light'
}[window.__DOMAIN__]

const PageHeader = () => {
  const context = useContext(QuizContext)
  const isMobileView = useMediaQuery('(max-width: 767px)')

  if (window.__DOMAIN__ === 'immonet' || window.__DOMAIN__ === 'immowelt') {
    //@FF_DISABLE_QUIZ_FH_HEADER -
    return null
  }

  const openExitPrompt = () => {
    const modal = new Modal()
    modal.openModal({
      component: (
        <QuizDebounceModal
          flow={context.tracking.flow}
          config={context.data.debounceModal}
        />
      ),
      options: {
        className: 'centre:s',
        closeOnOutsideClick: true
      }
    })
  }

  const handleClick = event => {
    event.preventDefault()
    openExitPrompt()
  }
  const stepsBeforeCheckout = context.data.steps.findIndex(
    step => step.checkout
  )
  const currentStep = context.data.steps[context.data.stepIndex]

  const stepCount =
    context.data.stepIndex + 1 > stepsBeforeCheckout
      ? stepsBeforeCheckout
      : context.data.stepIndex + 1

  const isCheckoutStep = currentStep.checkout
  const isValidation = currentStep.validation
  const isCheckoutOrValidation = isCheckoutStep || isValidation

  return (
    <header
      className={classNames('PageHeader-wrapper PageHeader-wrapper--compact', {
        'PageHeader-wrapper--fixed': context.displayCheckoutWithImage,
        'PageHeader-wrapper--checkout': isCheckoutOrValidation
      })}>
      <div
        className={classNames(
          'f-p-h-020 f-d-flr f-fl-al-ce f-fl-jc-sb f-wrap'
        )}>
        <a
          href='/'
          className='[ f-d-inbl ] PageHeader-logo-link PageHeader-logo-link--compact'
          onClick={handleClick}
          aria-label='zur Homepage'>
          {(isCheckoutOrValidation && window.__DOMAIN__ !== 'bungalow') ||
          !isMobileView ? (
            <PlatformLogo />
          ) : (
            <PlatformLogoOnWhite />
          )}
        </a>
        <div className='PageHeader-step-count PageHeader-step-count--navbar'>
          {!currentStep.hidesProgressBar && (
            <span className='[ f-t-body ] QuizProgress-bar__label QuizProgress-bar__label--compact'>
              Frage: {stepCount}/{stepsBeforeCheckout}
            </span>
          )}
        </div>
        {isCheckoutOrValidation &&
          isMobileView &&
          !context.data.exclusiveVendorNid && (
            <div className='f-d-flr f-fl-al-ce'>
              <StarRating backgroundType={backgroundTypeByDomain} />
              <div className='f-t-body PageHeader-stars'>4,4 / 5</div>
            </div>
          )}
      </div>
    </header>
  )
}

export default PageHeader
